import { useMemo } from "react";

import { Rule } from "antd/es/form";
import { useIntl } from "react-intl";

import messages from "./messages";

const useWorkingHoursValidationRules = (): Rule[] => {
  const intl = useIntl();

  return useMemo(
    () => [
      (form) => ({
        validator: () => {
          const [from, to] = form.getFieldValue("workingHours");
          if (!!from && !!to && from === to) {
            return Promise.reject(intl.formatMessage(messages.workingHoursEqualDatesError));
          }

          return Promise.resolve();
        },
      }),
    ],
    [intl]
  );
};

export default useWorkingHoursValidationRules;
